import { render, staticRenderFns } from "./storageSpace.vue?vue&type=template&id=0cef2a7e&scoped=true"
import script from "./storageSpace.vue?vue&type=script&lang=js"
export * from "./storageSpace.vue?vue&type=script&lang=js"
import style0 from "./storageSpace.vue?vue&type=style&index=0&id=0cef2a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cef2a7e",
  null
  
)

export default component.exports